module.exports = __webpack_public_path__ + "static/media/riskFactors.5271e47d.mp3";